// taken from: https://github.com/tserkov/vue-plugin-load-script/blob/master/index.js
export function loadScript(src, config = {}) {
    return new Promise(function (resolve, reject) {
        let shouldAppend = false;
        let el = document.querySelector('script[src="' + src + '"]');
        if (!el) {
            el = document.createElement('script');
            el.type = config.type || 'text/javascript';
            el.defer = true;
            el.src = src;
            shouldAppend = true;
            if (config.dataAttributes) {
                for (const [key, value] of Object.entries(config.dataAttributes)) {
                    el.setAttribute('data-' + key, value);
                }
            }
        }
        else if (el.hasAttribute('data-loaded')) {
            resolve(el);
            return;
        }
        el.addEventListener('error', reject);
        el.addEventListener('abort', reject);
        el.addEventListener('load', function loadScriptHandler() {
            el.setAttribute('data-loaded', "true");
            resolve(el);
        });
        if (shouldAppend)
            document.head.appendChild(el);
    });
}
